import styled from "styled-components";

const StyledModalCont = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  pointer-events: none;
  z-index: 2;

  .portal-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .portal-sticky {
    position: sticky;
    width: 100vw;
    height: calc(var(--vh, 1vh) * 100);
    top: 0;
  }
`;

export default StyledModalCont;
